import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export enum TextSpacing {
  NONE = 0,
  X_SMALL = 8,
  SMALL = 16,
  MEDIUM_SMALL = 20,
  MEDIUM = 24,
  LARGE = 32,
  X_LARGE = 40,
}

export enum TextWeight {
  REGULAR = 400,
  MEDIUM = 500,
  SEMI_BOLD = 600,
  BOLD = 700,
}

export enum TextAlign {
  LEFT = 'left',
  CENTER = 'center',
}

export enum TextSize {
  BODY_0 = 12,
  BODY_1 = 14,
  BODY_2 = 16,
  BODY_3 = 18,
  BODY_4 = 20,

  TITLE_0 = 16,
  TITLE_1 = 18,
  TITLE_2 = 20,
  TITLE_3 = 24,
  TITLE_4 = 26,
  TITLE_5 = 32,
}

export enum TextHeight {
  BODY_0 = 19, // old 18
  BODY_1 = 22, // old 21
  BODY_2 = 26, // old 24
  BODY_3 = 29, // old 26
  BODY_4 = 32,

  TITLE_0 = 19, // old 20
  TITLE_1 = 22, // old 22
  TITLE_2 = 26, // old 24
  TITLE_3 = 29, // old 29
  TITLE_4 = 32,

  SMALLER = 18,
  SMALL = 21,
  MEDIUM = 24,
  LARGE = 26,
  LARGER = 29,
}

export enum TextColor {
  NEUTRAL_0 = 'neutral-0',
  NEUTRAL_6 = 'neutral-6',
  NEUTRAL_7 = 'neutral-7',
  NEUTRAL_8 = 'neutral-8',
}

export enum TextType {
  BODY = 'body',
  TITLE = 'title',
}

/**
 * TextStyle will override the size, weight, and height arguments.
 */
export enum TextStyle {
  BODY_0_REGULAR = 'body-0-regular',
  BODY_0_MEDIUM = 'body-0-medium',
  BODY_0_SEMI_BOLD = 'body-0-semi-bold',
  BODY_1_REGULAR = 'body-1-regular',
  BODY_1_MEDIUM = 'body-1-medium',
  BODY_1_SEMI_BOLD = 'body-1-semi-bold',
  BODY_2_REGULAR = 'body-2-regular',
  BODY_2_MEDIUM = 'body-2-medium',
  BODY_2_SEMI_BOLD = 'body-2-semi-bold',
  BODY_3_REGULAR = 'body-3-regular',
  BODY_3_MEDIUM = 'body-3-medium',
  BODY_3_SEMI_BOLD = 'body-3-semi-bold',
  BODY_4_REGULAR = 'body-4-regular',
  BODY_4_MEDIUM = 'body-4-medium',
  BODY_4_SEMI_BOLD = 'body-4-semi-bold',

  TITLE_0_REGULAR = 'title-0-regular',
  TITLE_0_MEDIUM = 'title-0-medium',
  TITLE_0_SEMI_BOLD = 'title-0-semi-bold',
  TITLE_1_REGULAR = 'title-1-regular',
  TITLE_1_MEDIUM = 'title-1-medium',
  TITLE_1_SEMI_BOLD = 'title-1-semi-bold',
  TITLE_2_REGULAR = 'title-2-regular',
  TITLE_2_MEDIUM = 'title-2-medium',
  TITLE_2_SEMI_BOLD = 'title-2-semi-bold',
  TITLE_3_REGULAR = 'title-3-regular',
  TITLE_3_MEDIUM = 'title-3-medium',
  TITLE_3_SEMI_BOLD = 'title-3-semi-bold',
}

export enum TextHeadingLevel {
  PAGE = 1,
  CONTENT = 2,
}

@Component({
  standalone: true,
  selector: 'app-text',
  imports: [CommonModule],
  templateUrl: './text.component.html',
  styleUrl: './text.component.css',
})
export class TextComponent {
  @Input() size = TextSize.BODY_2;
  @Input() weight = TextWeight.MEDIUM;
  @Input() height = TextHeight.MEDIUM;
  @Input() align = TextAlign.LEFT;
  @Input() color = TextColor.NEUTRAL_7;
  @Input() type = TextType.BODY;
  @Input() style!: TextStyle;
  @Input() heading = TextHeadingLevel.CONTENT;
  @Input() spacingBottom = TextSpacing.NONE;
  @Input() testId!: string;
  @Input() pointerEventsDisabled = true;

  TextStyle = TextStyle;
  TextType = TextType;
  TextHeadingLevel = TextHeadingLevel;
}
